import type { ConfidenceLevel } from "@opus-dt/prisma-schema";
import type { SimOverride } from "../api-contracts/scenarios.js";

// Fórmulas do PREVIEW LEVE compartilhadas entre server (apps/api scenario-preview) e
// client (apps/web preview-engine/SimParamFields) + worker (engine-params). Fonte ÚNICA: se as
// duas pontas calculassem por conta própria, o preview e a rodada divergiriam de gargalo/confiança
// — exatamente o que este módulo elimina.

/** RITMO canônico: o override de ciclo LEGADO dobra-se INVERSAMENTE no ritmo
 * (ciclo maior ⇒ máquina mais lenta ⇒ ritmo menor — invariante 6). Os deltas já
 * vêm clampados a ±25% pelo SimOverrideSchema, então `1 + cycleDeltaPct/100 ∈ [0.75, 1.25]` (nunca
 * zero). Usado por api/web/worker para nunca divergir na aplicação do override. */
export function effectiveFeedRate(
  baseFeedUnH: number,
  feedDeltaPct = 0,
  cycleDeltaPct = 0
): number {
  return (baseFeedUnH * (1 + feedDeltaPct / 100)) / (1 + cycleDeltaPct / 100);
}

/** Delta cru (pct) de um override por parâmetro (0 se ausente). Fonte única do extrator usado por
 * server/client/sheet p/ alimentar `effectiveFeedRate` de forma consistente. */
export function deltaPctOf(overrides: SimOverride[] | undefined, param: string): number {
  return overrides?.find((o) => o.param === param)?.deltaPct ?? 0;
}

/** Confiança do preview leve: fração de parâmetros MEDIDOS × fator de janela (janela
 * curta ⇒ menos confiança). Server e client chamam ISTO — nunca divergem no nível exibido. */
export function previewConfidence(
  measuredParams: number,
  totalParams: number,
  calibrationDays: number
): ConfidenceLevel {
  if (totalParams === 0) return "INSUFFICIENT";
  const windowFactor = Math.max(0.75, Math.min(1, 0.7 + calibrationDays / 300));
  const frac = (measuredParams / totalParams) * windowFactor;
  if (frac >= 0.75) return "HIGH";
  if (frac >= 0.5) return "MEDIUM";
  if (frac >= 0.25) return "LOW";
  return "INSUFFICIENT";
}
